const keyConfig = {
  languageKey: "hrmsDemoWebLanguage",
  themeKey: "hrmsDemoWebTheme",
  tokenKey: "hrmsDemoWebStaffToken",
};

export default keyConfig;
